import * as React from "react";
import CoughAnalysisQueryTable from "./CoughAnalysisQueryTable";
import { Filter, ODataParams, Query } from "../../Components/Query";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";


export interface CoughAnalysisScreenProps {
    filters: Filter[];
    onFiltersApplied: (filters: Filter[]) => void;
}

export const CoughAnalysisScreen = (props: CoughAnalysisScreenProps) => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams) => {
        const select = 'id,sessionId,sessionWaveform,type,typeName,analysisDeadline,firstComplete,qaDeadline,status,statusName,isLinkedAnalysisSet,reviewStatus,reviewRequired,reviewComplete,reOpenedDuringReview,visualReviewAnalystSelectionId,visualReview,analyst,firstAnalyst,qaAnalyst,qaAnalystStageDateTime,firstAnalystAssignedDateTime,created,started,modified,linksSourcedFromThis,linksTargetingThis,session';
        const expand = 'session($select=id,name,serialNumber,deviceType,lastReceived,visit;$expand=visit($select=id,name,subjectId,subject;$expand=subject($select=id,number,siteId,site;$expand=site($select=id,number))))';
        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `session/visit/subject/site/studyId eq ${study.id}`;

        return await client.client.getCoughAnalysisSets(select, filter, params.orderby, expand, params.top, params.skip, undefined, true);
    }

    return (
        <DocumentTitle title="Cough Analysis Sets | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh} initialFilters={props.filters} onFiltersApplied={props.onFiltersApplied} initialOrdering={[{ field: "session/lastReceived", condition: "desc" }]}>
                <CoughAnalysisQueryTable />
            </Query>
        </DocumentTitle>
    );
}
